module.exports = __webpack_public_path__ + "img/pay-welfare-banner.eedd3f55.png";